module.exports = __webpack_public_path__ + "img/u84.acac94c3.jpg";